import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AuthentificationService } from '../../../providers/Global/authentification.service';
import { EditService } from '../../../providers/edit/edit.service';
import { DropzoneService } from '../../../providers/Import/dropzone.service';

import { MatTableDataSource } from '@angular/material/table';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { EditWinmediaDialogComponent } from './editWinmediaDialog.component';

import { Globals } from '../../../ressources/variables/globals';

interface EditWinmediaCategory {
  id: number;
  label: string;
}

@Component({
  selector: 'app-edit-winmedia',
  templateUrl: './editWinmedia.component.html',
  styleUrls: ['./editWinmedia.component.scss']
})
export class EditWinmediaComponent implements OnInit {

  permissions: Array<string> = [];

  @ViewChild('Paginator', {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  medias: [] = [];
  displayedColumns: string[] = ['player', 'imedia', 'performer', 'title', 'version', 'proprietes', 'mood3', 'modify', 'edit'];
  mediasMatTable;

  proprietes: [] = [];

  extraitLocation = Globals.websiteRacine + '/storage/winmedia/extraits/';

  loading = false;

  categories: EditWinmediaCategory[] = [];
  selectedCategory: EditWinmediaCategory | null = null;

  searchTerm = '';

  constructor(private router: Router,
              private authentificationService: AuthentificationService,
              private editService: EditService,
              private dropzoneService: DropzoneService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              private dialog: MatDialog) {
    this.permissions = this.authentificationService.permissionsSource.getValue();
    iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/edit.svg'));
    iconRegistry.addSvgIcon('play', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/play.svg'));
    iconRegistry.addSvgIcon('stop', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/stop.svg'));
  }

  ngOnInit() {
    if (this.permissions.includes('edit_winmedia_sql')) {
      this.dropzoneService.getProprietes()
        .then(res => {
          this.proprietes = res.map(x => x.label);
        })
        .catch(() => {
          this.proprietes = [];
        });

      this.editService.getEditWinmediaCategories()
        .then(res => {
          this.categories = res;
        })
        .catch(() => {
          this.categories = [];
        });
    } else {
      this.router.navigate(['']).then(r => {
        console.log(r);
      });
    }
  }

  onCategoryChange(category: EditWinmediaCategory | null) {
    this.searchTerm = '';
    this.selectedCategory = category;
    if (!category) {
      delete this.mediasMatTable;
      this.medias = [];
      return;
    }
    this.loadCategory(category);
  }

  onSearch() {
    const term = this.searchTerm.trim();
    if (term.length < 2) return;
    this.selectedCategory = null;
    this.loading = true;
    delete this.mediasMatTable;

    this.editService.searchWinmedia(term)
      .then(res => {
        this.medias = res.recordset;
        this.buildTable(this.medias);
        this.loading = false;
      })
      .catch(() => this.loading = false);
  }

  private loadCategory(category: EditWinmediaCategory) {
    this.loading = true;
    delete this.mediasMatTable;

    this.editService.getWinmediaPreselectCategory(category.label)
      .then(res => {
        this.medias = res.recordset;
        this.buildTable(this.medias);
        this.loading = false;
      })
      .catch(() => this.loading = false);
  }

  private buildTable(data: []) {
    this.mediasMatTable = new MatTableDataSource<[]>(data);
    this.mediasMatTable.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = 'Eléments affichés par page';
    this.paginator._intl.nextPageLabel = '';
    this.paginator._intl.previousPageLabel = '';
    this.paginator._intl.firstPageLabel = '';
    this.paginator._intl.lastPageLabel = '';
    this.mediasMatTable.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'modify': return new Date(item.modify);
        default: return item[property];
      }
    };
    this.mediasMatTable.sort = this.sort;
  }

  editDialog(element) {
    const dialogRef = this.dialog.open(EditWinmediaDialogComponent, {
      width: '250px',
      data: {
        element: element,
        proprietes: this.proprietes
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.change) {
        this.editService.updateProprietes(element.imedia, result.proprietesReturn, result.mood3Return)
          .then(res => {
            console.log(res);
            element.proprietes = result.proprietesReturn;
            element.mood3 = result.mood3Return;
          })
          .catch(err => {
            console.log(err);
          });
      }
    });
  }

}
